import { render, staticRenderFns } from "./data-import.vue?vue&type=template&id=5b6e6dde&scoped=true"
import script from "./data-import.vue?vue&type=script&lang=js"
export * from "./data-import.vue?vue&type=script&lang=js"
import style0 from "./data-import.vue?vue&type=style&index=0&id=5b6e6dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e6dde",
  null
  
)

export default component.exports